import React, { useContext } from 'react';
import { Row, Col } from "react-bootstrap";
import img from '../../../assets/Img';
import { useTranslation } from 'react-i18next';


const translations = {
    en: require('../../../Translate/en.json').DigitalMarketing,
    ar: require('../../../Translate/ar.json').DigitalMarketing,
};

const SEOandPPC = () => {
    const { i18n } = useTranslation();
    const isLang = i18n.language;
    const t = translations[isLang || 'en'];

    return (
        <div className="services-section">
            <Row gutter={[32, 32]} align="middle">
                {/* ✅ SEO Section */}
                <Col xs={12} md={6}>
                    <h2 className={`section-title ${isLang == "en" ? 'text-start' : 'text-end'}`}>{t.SEO.title}</h2>
                    <p className={`section-subtitle ${isLang == "en" ? 'text-start' : 'text-end'}`}>{t.SEO.subtitle}</p>
                    <ul className="service-list">
                        {Object.keys(t.SEO.services).map((key, index) => (
                            <li key={index} className={`${isLang == "en" ? 'text-start' : 'text-end'}`}>
                                <strong>{t.SEO.services[key].title}:</strong> {t.SEO.services[key].description}
                            </li>
                        ))}
                    </ul>
                </Col>

                <Col xs={12} md={6} className="flex justify-content-center align-items-center">
                    <img
                        width={500}
                        height={300}
                        src={img.Dicon4}
                        alt="SEO illustration"
                        className="service-image"
                    />
                </Col>

                {/* ✅ PPC Section */}
                <Col xs={12} md={6} className="flex justify-content-start align-items-start">
                    <img
                        width={500}
                        height={300}
                        src={img.Dicon1}
                        alt="PPC illustration"
                        className="service-image"
                    />
                </Col>

                <Col xs={12} md={6}>
                    <h2 className={`section-title ${isLang == "en" ? 'text-start' : 'text-end'}`}>{t.PPC.title}</h2>
                    <p className={`section-subtitle ${isLang == "en" ? 'text-start' : 'text-end'}`} >{t.PPC.subtitle}</p>
                    <ul className="service-list  ">
                        {Object.keys(t.PPC.services).map((key, index) => (
                            <li key={index} className={`${isLang == "en" ? 'text-start' : 'text-end'}`}>
                                <strong>{t.PPC.services[key].title}:</strong> {t.PPC.services[key].description}
                            </li>
                        ))}
                    </ul>
                </Col>
            </Row>
        </div>
    );
};

export default SEOandPPC;
